"use strict";

var LoggerInstance = require("js-logger").get("ExpanderStore");

var AbstractStore = require("./AbstractStore");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	isDesignMode: false
};

var ExpanderStore = class extends AbstractStore {
	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}
};

ExpanderStore.dispatchToken = Dispatcher.register(function (action) {
	switch (action.actionType) {
		case Constants.EXPANDER_INITIALIZE:
			state.isDesignMode = action.isDesignMode;
			return true; // Don't emit change

		default:
			// no op
			return true;
	}

	ExpanderStore.emitChange();
	return true;
});

module.exports = new ExpanderStore();
